import { Component, Input, ChangeDetectionStrategy } from '@angular/core';


export class ProgressBarComponent {

   state;
   positionUsing;
   ease;
   speed;
   showSpinner;
   direction;
   thick;
   color;

  /** Styles for progressbar */
  barStyles() {
    let styles = {
      transition: `all ${this.speed}ms ${this.ease}`,
      backgroundColor: this.color
    };
    /** Get positioning value */
    let n = (!this.state.value) ? {
      leftToRightIncreased: -100,
      leftToRightReduced: 0,
      rightToLeftIncreased: 100,
      rightToLeftReduced: 0
    }[this.direction] : this.toPercentage(this.state.value);

    switch (this.positionUsing) {
      case 'translate3d':
        styles = Object.assign({}, styles, {
          transform: `translate3d(${n}%,0,0)`,
          '-webkit-transform': `translate3d(${n}%,0,0)`,
          '-moz-transform': `translate3d(${n}%,0,0)`,
          '-o-transform': `translate3d(${n}%,0,0)`,
          '-ms-transform': `translate3d(${n}%,0,0)`
        });
        break;
      case 'translate':
        styles = Object.assign({}, styles, {
          transform: `translate(${n}%,0)`,
          '-webkit-transform': `translate(${n}%,0)`,
          '-moz-transform': `translate(${n}%,0)`,
          '-o-transform': `translate(${n}%,0)`,
          '-ms-transform': `translate(${n}%,0)`
        });
        break;
      default:
        styles = Object.assign({}, styles, {
          marginLeft: `${n}%`
        });
    }
    return styles;
  }

  /** Styles for progressbar tail */
  shadowStyles() {
    return {
      boxShadow: `0 0 10px ${this.color}, 0 0 5px ${this.color}`
    };
  }

  toPercentage(n) {
    return ({
      leftToRightIncreased: -1 + n,
      leftToRightReduced: -n,
      rightToLeftIncreased: 1 - n,
      rightToLeftReduced: n
    }[this.direction]) * 100;
  }

  spinnerClasses() {
    return {
      leftToRightIncreased: 'clockwise',
      leftToRightReduced: 'anti-clockwise',
      rightToLeftIncreased: 'anti-clockwise',
      rightToLeftReduced: 'clockwise'
    }[this.direction];
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'ng-progress-bar',
  template: "\n    <div class=\"ng-progress\" *ngIf=\"state\" [class.active]=\"state.active\" [class.thick]=\"thick\">\n      <div class=\"bar\" [ngStyle]=\"barStyles()\">\n        <div class=\"bar-shadow\" [ngStyle]=\"shadowStyles()\"></div>\n      </div>\n      <div *ngIf=\"showSpinner\" class=\"spinner\" [ngClass]=\"spinnerClasses()\">\n        <div class=\"spinner-icon\" [style.borderTopColor]=\"color\" [style.borderLeftColor]=\"color\"></div>\n      </div>\n    </div>\n  ",
  changeDetection: ChangeDetectionStrategy.OnPush
}, ] },
];
/** @nocollapse */
static ctorParameters: ({type: any, decorators?: DecoratorInvocation[]}|null)[] = [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'state': [{ type: Input },],
'positionUsing': [{ type: Input },],
'ease': [{ type: Input },],
'speed': [{ type: Input },],
'showSpinner': [{ type: Input },],
'direction': [{ type: Input },],
'thick': [{ type: Input },],
'color': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
